import React from "react";
import useCopyToClipboard from "../../effects/useCopyToClipboard";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import { Button, Tooltip } from "@mui/material";
import { green } from "@mui/material/colors";

export default function CopyButton({ code }: { code: any }) {
  const [isCopied, handleCopy] = useCopyToClipboard(1500);

  return (
    <Tooltip title="Click to copy" arrow>
      <Button onClick={() => handleCopy(code)}>
        {isCopied ? (
          <DoneOutlinedIcon style={{ color: green[800] }} />
        ) : (
          <FileCopyOutlinedIcon color="primary" />
        )}
      </Button>
    </Tooltip>
  );
}
